import {PaymentsFromTransactionResponse} from "@/types/service-response";

export class PaymentFromTransaction {
  private constructor (
    readonly id: number,
    readonly createdAt: string,
    readonly status: string,
    readonly datePosted: string,
    readonly dateAvailable: string,
    readonly amount: number,
    readonly variableSymbol: number,
    readonly specificSymbol: number,
    readonly constantSymbol: number,
    readonly name: string,
    readonly reference: string,
    readonly memo: string,
    readonly fromIban: string,
    readonly currency: string
  ) {}

  static createFromResponse (responseData: PaymentsFromTransactionResponse[]): PaymentFromTransaction[] {
    return responseData.map((item: PaymentsFromTransactionResponse) => {
      return new PaymentFromTransaction(
          item.id,
          item.createdAt,
          item.status,
          item.datePosted,
          item.dateAvailable,
          item.amount,
          item.variableSymbol,
          item.specificSymbol,
          item.constantSymbol,
          item.name,
          item.reference === 'not-provided' ? ' ' : item.reference,
          item.memo,
          item.fromIban,
          item.currency
      )
    })
  }
}
